import ReactDOM from 'react-dom/client'
import App from './App'
import { registerSW } from 'virtual:pwa-register'

export const updateSW = registerSW({ immediate: true })

ReactDOM.createRoot(document.getElementById('root')!).render(<App />)
